<script>
import { Article } from '@/api'
import fields from '@/components/fields/'
import moment from 'moment'
import PageFormBase from '@/crudBases/form/PageFormBase'
import Mixin from '@/views/Articles/Mixin'

export default {
  mixins: [PageFormBase, Mixin],
  data() {
    return {
      form: {
        widgets: [],
      },
      redirectRoute: { name: 'Article List' },
      livePreview: true,
      pageType: 'Article'
    }
  },
  created() {
    this.fetchTags()
    if (this.form.publication_date === undefined) {
      this.$set(this.form, 'publication_date', moment().format('YYYY-MM-DD'))
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            this.getGeneralTab(),
            this.getWidgetsTab(),
            this.getPreviewTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            required: true,
            modelPath: [this, 'form', 'title'],
            type: 'textarea'
          }),
          new fields.Input({
            label: 'Lead',
            required: true,
            modelPath: [this, 'form', 'lead'],
            type: 'textarea'
          }),
          new fields.Select({
            label: 'Tagi',
            modelPath: [this, 'form', 'tags'],
            multiple: true,
            filterable: true,
            allowCreate: true,
            options: this.tagOptions
          }),
          new fields.Date({
            label: 'Data publikacji',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            modelPath: [this, 'form', 'publication_date'],
            required: true
          })
        ]
      }
    },
  },
  computed: {
    service() {
      return Article
    }
  }
}
</script>
